module.exports = __webpack_public_path__ + "static/media/chess-rook.382e5777.svg";